export default __webpack_public_path__ + "static/media/RCSP-ENTERPRISE.59baceb5.jpg";